<template>
  <b-form-select
    :id="id"
    :value="multiple ? value || [] : value"
    :options="ecosystemOptions"
    :multiple="multiple"
    :select-size="multiple ? 8 : 0"
    :required="required"
    @change="onChange"
  />
</template>

<script>
// Select of ecosystems by id and name (MOOV-5543), used through the engine's componentEdit: single for an id
// such as `default_ecosystem_id`, multiple for an id array such as `shares_from`. An empty multiple selection is
// sent as null, like the ecosystems that never shared.
export default {
  name: 'EcosystemSelect',
  props: {
    value: {
      type: [Number, Array],
      default: null
    },
    id: {
      type: String,
      default: 'ecosystem-select'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    // Ecosystem left out of the options, e.g. the one being edited
    excludeId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      ecosystems: []
    }
  },
  computed: {
    ecosystemOptions() {
      return this.ecosystems
        .filter(x => x.id !== this.excludeId)
        .map(x => ({ value: x.id, text: '#' + x.id + ' — ' + x.name }))
    }
  },
  created() {
    // GET /ecosystems paginates by default; the explicit limit brings them all
    this.$http.get(this.$appConfig.api.baseUrl + 'ecosystems', { params: { fields: 'id,name', limit: 1000 } })
      .then(response => {
        this.ecosystems = response.body.data
      })
  },
  methods: {
    onChange(selected) {
      this.$emit('input', this.multiple && !selected.length ? null : selected)
    }
  }
}
</script>
